import type { ReactNode } from 'react';
import type { FaqItem } from './faq.types';
import { FaqAccordion } from './FaqAccordion';

type PageFaqSectionProps = {
  items?: readonly FaqItem[];
  title: ReactNode;
  titleAs?: 'h1' | 'h2';
  eyebrow?: string;
  initialOpenIndex?: number | null;
  id?: string;
  children?: ReactNode;
  tone?: 'light' | 'dark';
};

export function PageFaqSection({
  items,
  title,
  titleAs = 'h2',
  eyebrow = '- Questions',
  initialOpenIndex = null,
  id = 'resources',
  children,
  tone = 'dark',
}: PageFaqSectionProps) {
  const Heading = titleAs;

  return (
    <section className={`${tone === 'light' ? 'band-light' : 'band-dark'} page-faq-section`} id={id}>
      <div className="container">
        <div className="grid [grid-template-columns:1fr_1.4fr] gap-20 items-start mb-14 reveal max-lg:grid-cols-1 max-lg:gap-6">
          <div>
            <p className="label-mono">{eyebrow}</p>
            <Heading className="home-section-title m-0 mt-[18px]">{title}</Heading>
          </div>
          {children ?? (items ? <FaqAccordion items={items} initialOpenIndex={initialOpenIndex} /> : null)}
        </div>
      </div>
    </section>
  );
}
